import React from 'react';
import '../css/Header.css';

interface HeaderProps {
    onAboutClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onAboutClick }) => {
    return (
        <div className="header">
            <div className="header-content">
                <div className="logo">
                    <img src={process.env.PUBLIC_URL + '/goldencross-logo.svg'} width="60"></img>
                </div>
                <div className="nav">
                    <div>
                        <a href="/">Home</a>
                    </div>
                    <div>
                        <a href="#about" onClick={onAboutClick}>
                            About
                        </a>
                    </div>
                    <div>
                        <a href="https://secure.m4markets.com/ko/login?sl=1" target="_blank" rel="noopener noreferrer">
                            Login
                        </a>
                    </div>
                    <div>
                        <a
                            href="https://secure.m4markets.com/ko/links/go/5852"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Sign Up
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
